import useMsiEffectTitle from './useMsiEffectTitle'
import isStandardQuestion from '../helpers/questionnaire/isStandardQuestion'
import questionHeading from '../helpers/questionnaire/questionHeading'

/**
 * De kop boven de grafiek van één vraag in een live rapportage.
 *
 * Nodig omdat twee widgets dezelfde vraag beantwoorden ('Onderzoek' per vraag,
 * 'Vraag' voor één vraag) en die eerst elk hun eigen regel hadden — de ene
 * herkende een meetstandaardvraag niet, de andere maar half (testronde en
 * risicocheck 2026-10-13). Bij een meetstandaardvraag is de vraagtekst bij elk
 * effect dezelfde ('In welke mate ben je het eens met de volgende
 * stellingen?'), dus is de kop de naam van het effect, net als op de kaart
 * buiten de rapportage (`ResearchData` → `MsiEffectTitle`). Is dat effect niet
 * te vinden, dan '' — liever geen kop dan vier keer dezelfde.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {{Question?: string, Title?: string, Standard?: string|boolean, MSIId?: string, EffectId?: string|string[]}|null|undefined} field - QuestionnaireFields-document
 * @returns {string} De kop, of '' als er geen is
 */
const useQuestionHeading = (field) => {
    const standard = isStandardQuestion(field)
    const effectTitle = useMsiEffectTitle(standard ? field?.EffectId : '')
    return questionHeading(field, effectTitle)
}

export default useQuestionHeading
